import React, { useEffect, useState } from 'react';

import CardContainer from 'components/Tvendo/Common/CardContainer';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { ConstantPermissions } from 'contexts/useConstant';
import Button from 'components/CustomButtons/Button.js';
import { wsGetAll, wsFindBy } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import { Visibility } from '@material-ui/icons';
import { useModal } from 'hooks/useModal';
import Modal from './CloseWorkDayModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Zona', accessor: 'zone', width: 200 },
  { Header: 'Mesa', accessor: 'bureau', width: 200 },
  { Header: 'Canal', accessor: 'canal', width: 200 },
  { Header: 'Hora de cierre', accessor: 'close_hour' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function CloseWorkDayList() {
  const [closingData, setClosingData] = useState([]);
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  function reload(search = undefined) {
    setDataLoading(true);
    if (search !== undefined) {
      wsFindBy('ordm/closing-work-day', search).then((response) => {
        setClosingData(response.data);
        setDataLoading(false);
      });
    } else {
      wsGetAll('ordm/closing-work-day').then((response) => {
        setClosingData(response.data)
        setDataLoading(false);
      });
    }
  }

  useEffect(() => {
    setDataLoading(true);
    wsGetAll('ordm/closing-work-day').then((response) => {
      setClosingData(response.data)
      setDataLoading(false);
    });
  }, []);

  return (
    <CardContainer /*title="Configuración de cierre de jornada"*/ title={(<>Configuración de cierre de jornada {dataLoading && <LoadingSpinner />}</>)}>
      <Toasty action={notify} />
      <FilterCustom zone bureau getFilter={reload} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={reload} />

      <ReactTable
        columns={columns}
        data={closingData.map((item, i) => {
          return {
            num: (
              <>
                {i + 1}
                <AllowedGuard permission={ConstantPermissions.ORDM_CLOSING_WORK_DAYS_UPDATE}>
                  <Button
                    justIcon
                    round
                    simple
                    color="primary"
                    onClick={() => setOpen(item)}
                    className="like"
                  >
                    <Visibility />
                  </Button>
                </AllowedGuard>
              </>
            ),
            zone: item.zone.description,
            canal: item.canal.description,
            bureau: item.bureau?.description ?? '',
            close_hour: item.close_hour ?? 'No asignado',
          };
        })}
      />
    </CardContainer>
  );
}

export default CloseWorkDayList;
